// components/RootRedirect.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RootRedirect = () => {
	const navigate = useNavigate();
	const isAuthenticated = !!localStorage.getItem("parallextoken"); // Or use your auth method

	useEffect(() => {
		if (isAuthenticated) {
			navigate("/dashboard", { replace: true });
		} else {
			navigate("/login", { replace: true });
		}
	}, [isAuthenticated, navigate]);

	return null;
};

export default RootRedirect;
